import { environment } from '@/environments/environment'

interface BeamerConfig {
  product_id: string
  user_id?: string
  button: false
}

declare global {
  interface Window {
    beamer_config?: BeamerConfig
  }
}

const BEAMER_URL = 'https://app.getbeamer.com/js/beamer-embed.js'
const BEAMER_SCRIPT_ID = 'beamer-embed-script'

export function loadBeamer(userId: string) {
  if (!environment.beamerId)
    return

  window.beamer_config = {
    product_id: environment.beamerId,
    user_id: userId,
    button: false,
  }

  if (document.getElementById(BEAMER_SCRIPT_ID))
    return

  const script = document.createElement('script')
  script.id = BEAMER_SCRIPT_ID
  script.src = BEAMER_URL
  script.async = true
  document.body.appendChild(script)
}
